import { ActivateDebitCardMutationResponse } from 'pages/GlobalModals/AddCardModal/hooks/useActivateCard/graphql/ActivateDebitCard.generated'

export type ActivateDebitCardResponse =
  ActivateDebitCardMutationResponse['activateDebitCard']

export enum CardSize {
  SMALL = 'SMALL',
  LARGE = 'LARGE',
}
